module.exports = __webpack_public_path__ + "static/media/swapInline2.cde2d7aa.svg";